import { ReviewStatus } from '../../../views/cs/review/common/types/ReviewDetailTypes';
import { makeSelectList } from '../../../lib/common';

/**
 *  페이지
 */
export const CS_REVIEW_PAGE_NAME = {
  REVIEW_DETAIL: '상품 후기 상세',
  REVIEW_LIST: '상품 후기 리스트',
  REVIEW_CREATE: '상품 후기 등록',
};

/**
 *  상품 후기 문의 별점 SELECT 리스트
 */
export const CS_REVIEW_RATE_SELECT_LIST = [
  {
    id: 1,
    name: 1,
  },
  {
    id: 2,
    name: 2,
  },
  {
    id: 3,
    name: 3,
  },
  {
    id: 4,
    name: 4,
  },
  {
    id: 5,
    name: 5,
  },
];

export const CS_REVIEW_STATUS = {
  submit: 'submit',
  deleteFromUser: 'deleteFromUser',
  deleteFromAdmin: 'deleteFromAdmin',
};

export const REVIEW_STATUS_TEXT = {
  [ReviewStatus.SUBMIT]: '작성 완료',
  [ReviewStatus.DELETED_FROM_USER]: '구매자가 삭제',
  [ReviewStatus.DELETED_FROM_ADMIN]: '관리자가 삭제',
};

/**
 *  상품 후기 문의 상태 SELECT 리스트
 */
export const CS_REVIEW_STATUS_SELECT_LIST = makeSelectList(CS_REVIEW_STATUS, REVIEW_STATUS_TEXT);

export const CS_REPORTED_REVIEW = '신고된 후기';
export const CS_GENERAL_REVIEW = '일반 후기';

export const CS_IS_REPORTED_REVIEW_SELECT_LIST = [
  { id: true, name: CS_REPORTED_REVIEW },
  { id: false, name: CS_GENERAL_REVIEW },
];

export const CS_REVIEW_ATTACHMENT_EXISTS = {
  exists: true,
  notExists: false,
};

export const CS_REVIEW_ATTACHMENT_EXISTS_TEXT = {
  [CS_REVIEW_ATTACHMENT_EXISTS.exists]: '존재',
  [CS_REVIEW_ATTACHMENT_EXISTS.notExists]: '없음',
};

export const CS_REVIEW_ATTACHMENT_EXISTS_SELECT_LIST = makeSelectList(
  CS_REVIEW_ATTACHMENT_EXISTS,
  CS_REVIEW_ATTACHMENT_EXISTS_TEXT,
);

/**
 *  상품 후기 리스트가 없을 때 보여주는 텍스트
 */
export const CS_REVIEW_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 상품 후기 리스트가 없습니다.';

/**
 *  상품 후기 이미지 최대 개수
 */
export const MAXIMUM_NUMBER_OF_REVIEW_IMG = 3;

/**
 *  상품 후기 리스트 검색 키워드 타입
 */
export const CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE = {
  /**
   *  상품명
   */
  PRODUCT_NAME: 0,
  /**
   *  상품 ID
   */
  PRODUCT_ID: 1,
  /**
   *  상품 주문번호
   */
  ORDER_ITEM_ID: 2,
  /**
   *  구매자 ID
   */
  BUYER_ID: 3,
  /**
   *  구매자명
   */
  BUYER_NAME: 4,
  /**
   *  구매평
   */
  CONTENT: 5,
};

/**
 *  상품 후기 리스트 검색 키워드 타입 텍스트
 */
export const CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE_TEXT = {
  [CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_NAME]: '상품명',
  [CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_ID]: '상품 ID',
  [CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.ORDER_ITEM_ID]: '상품 주문번호',
  [CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.BUYER_ID]: '구매자 ID',
  [CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.BUYER_NAME]: '구매자명',
  [CS_REVIEW_LIST_SEARCH_KEYWORD_TYPE.CONTENT]: '구매평',
};

export const CS_REVIEW_CONTENT_MINIMUM = 20;

export const CS_REVIEW_CONTENT_LIMIT = 2000;

export const CS_REVIEW_POINT_MEMO_LIMIT = 1000;

export const CS_REVIEW_USER_DEFAULT_ID = 310;

export const REVIEW_CRITERIA_DEFAULT = [
  {
    type: 'size',
    id: 2,
  },
  {
    type: 'color',
    id: 5,
  },
  {
    type: 'thickness',
    id: 8,
  },
];
